type EsimVariation = 'none' | 'single' | 'multiple'

export interface EsimPromoCodesView {
  variation: EsimVariation
  codes: Array<App.LoyaltyEsimPromoCodeEntry>
  singleCode: App.LoyaltyEsimPromoCodeEntry | undefined
  orderPhase: App.LoyaltyEsimCodePhase | undefined
  isLoading: boolean
  isEligibleListReady: boolean
}

interface BuildEsimPromoCodesViewOptions {
  orderId?: string
  codesByOrderId: App.LoyaltyEsimPromoCodesState['codesByOrderId']
  benefitListLoaded: boolean
}

/** Builds the standardised view model for eSIM promo code(s) */
export function buildEsimPromoCodesView(
  visibleCodes: Array<App.LoyaltyEsimPromoCodeEntry>,
  { orderId, codesByOrderId, benefitListLoaded }: BuildEsimPromoCodesViewOptions,
): EsimPromoCodesView {
  const variation: EsimVariation = visibleCodes.length === 0
    ? 'none'
    : visibleCodes.length === 1
      ? 'single'
      : 'multiple'

  // Sorting codes
  const loadingOrGenerating = visibleCodes.filter(code => code.phase === 'loading' || code.phase === 'generating')
  const rest = visibleCodes.filter(code => code.phase !== 'loading' && code.phase !== 'generating')
  const codes = [...loadingOrGenerating, ...rest]

  const singleCode = variation === 'single' ? codes[0] : undefined
  const orderPhase = orderId
    ? codesByOrderId[orderId]?.phase
    : variation === 'single' && codes.length === 1
      ? codes[0]?.phase
      : undefined

  return {
    variation,
    codes,
    singleCode,
    orderPhase,
    isLoading: codes.some(code => code.phase === 'loading' || code.phase === 'generating'),
    isEligibleListReady: benefitListLoaded,
  }
}

export const EMPTY_ESIM_PROMO_CODES_VIEW: EsimPromoCodesView = buildEsimPromoCodesView([], {
  codesByOrderId: {},
  benefitListLoaded: false,
})
